import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import ApplyRounding from '../../../utils/math/ApplyRounding';
import { Tooltip } from '@material-ui/core';
import { resetSimAccount } from '../../../stores/websocketStore/utils/outgoingMessages/acctbalance/resetSimAccount';
import { modifyNickname } from '../../../stores/websocketStore/utils/outgoingMessages/acctbalance/modifyNickname';

function AccountIdRenderer(props) {
  let acctId = props.value;
  if (acctId === 'BACKTEST') {
    return (
      <>
        {acctId}
        <button
          style={{
            backgroundColor: 'red',
            borderColor: 'red',
            width: 15,
            height: 20,
            fontSize: 8,
            color: 'white',
            borderRadius: 3,
            borderWidth: 0,
          }}
          onClick={resetSimAccount}
        >
          R
        </button>
      </>
    );
  }
  return acctId;
}

export default class AgAccountBalances extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnNames: [
        {
          headerName: 'ACCOUNTS',
          children: [
            {
              headerName: 'nickname',
              field: 'nickname',
              resizable: true,
              editable: true,
            },
            {
              headerName: 'accountId',
              field: 'accountId',
              resizable: true,
              cellRenderer: 'accountIdRenderer',
            },
            {
              headerName: 'total equity',
              field: 'total_equity',
              resizable: true,
            },
            {
              headerName: 'total cash',
              field: 'total_cash',
              resizable: true,
            },
            {
              headerName: 'open P&L',
              field: 'open_pnl',
              resizable: true,
            },
            { headerName: 'closed P&L', field: 'closed_pnl', resizable: true },
            {
              headerName: 'optionBuyingPower',
              field: 'optionBuyingPower',
              resizable: true,
            },
            {
              headerName: 'stockBuyingPower',
              field: 'stockBuyingPower',
              resizable: true,
            },
          ],
        },
      ],
      frameworkComponents: {
        accountIdRenderer: AccountIdRenderer,
      },
    };
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridColumnApi = params.columnApi;
    var allColIds = params.columnApi
      .getAllColumns()
      .map((column) => column.colId);
    params.columnApi.autoSizeColumns(allColIds);

    // If you want to resize all columns
    //params.columnApi.autoSizeAllColumns();
  };

  render() {
    let accounts = this.props.values;
    let rows = {};
    // console.log(accounts);
    for (let accountId in accounts) {
      let account = accounts[accountId];
      rows[accountId] = {};
      let row = rows[accountId];
      row.accountId = accountId;
      row.nickname = account.nickname;
      row.closed_pnl = ApplyRounding(account.close_pl, 2);
      row.open_pnl = ApplyRounding(account.open_pl, 2);
      row.total_cash = ApplyRounding(account.total_cash, 2);
      // console.log(account);
      if (account.account_type === 'margin') {
        if (account.margin !== undefined) {
          row.optionBuyingPower = ApplyRounding(
            account.margin.option_buying_power,
            2
          );
          row.stockBuyingPower = ApplyRounding(
            account.margin.stock_buying_power,
            2
          );
        }
      } else if (account.account_type === 'cash') {
        if (account.cash !== undefined || account.cash !== null) {
          row.optionBuyingPower = ApplyRounding(account.cash.cash_available, 2);
          row.stockBuyingPower = ApplyRounding(account.cash.cash_available, 2);
        }
      } else if (account.account_type === 'pdt') {
        row.optionBuyingPower = ApplyRounding(
          account.pdt.option_buying_power,
          2
        );
        row.stockBuyingPower = ApplyRounding(account.pdt.stock_buying_power, 2);
      }
      row.total_equity = ApplyRounding(account.total_equity, 2);
    }
    if (this.refs.agGrid !== undefined) {
      this.refs.agGrid.api.refreshCells();
    }
    return (
      <div className="ag-theme-balham" style={{ width: '100%' }}>
        <AgGridReact
          ref="agGrid" // useful for accessing the component directly via ref
          gridAutoHeight={true}
          columnDefs={this.state.columnNames}
          rowData={Object.values(rows)}
          onGridReady={this.onGridReady.bind(this)}
          stopEditingWhenGridLosesFocus={true}
          onCellValueChanged={ModifyCell}
          singleClickEdit={true}
          frameworkComponents={this.state.frameworkComponents}
        />
      </div>
    );
  }
}

function ModifyCell(props) {
  modifyNickname(props.data.accountId, props.data.nickname);
}
